export const experienceData = [
  {
    id: 1,
    company: "Lenovo India/Sysnet Global PvT LtD.",
    jobtitle: "IT Engineer.",
    startYear: "August 2021.",
    endYear: "PresenT.",
  },
  {
    id: 2,
    company: "3I Electromation Technologies(freelance).",
    jobtitle: "Software  Engineer.",
    startYear: "April 2021.",
    endYear: "April 2022",
  },
  {
    id: 3,
    company: "Learning and Leveling up New skills Everyday.",
    jobtitle: "Self Learning.",
    startYear: "2016",
    endYear: "PresenT.",
  },
];
